import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".calendar", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" });
}
